import React, { useEffect, useRef } from 'react'
import { useSelector } from 'react-redux'
import { api } from '../utils'
import { TRADUZIONI } from '../utils/endpoint'

const replaceSostituzioni = (value, sostituzioni) => {
  let result = value
  if (sostituzioni?.length) {
    result = Object.values(sostituzioni).reduce(
      (prev, sost, i) => prev.replace(`{${i}}`, sost),
      value
    )
  }
  return result
}

const replaceSostituzioniRich = (value, sostituzioni = []) => {
  const parts = `${value || ''}`.split(/(\{\d+\})/g)

  return parts.map((part, index) => {
    const match = part.match(/^\{(\d+)\}$/)
    if (!match) return <React.Fragment key={`text-${index}`}>{part}</React.Fragment>

    return (
      <React.Fragment key={`replacement-${index}`}>{sostituzioni[Number(match[1])]}</React.Fragment>
    )
  })
}

const createTranslator = (translate) => {
  const translator = (chiave, sostituzioni) => translate(chiave, sostituzioni)
  translator.rich = (chiave, sostituzioni = []) =>
    replaceSostituzioniRich(translate(chiave), sostituzioni)

  return translator
}

export default function useTrans() {
  // Fix per Storybook
  if (process.env.STORYBOOK) {
    return createTranslator((chiave, sostituzioni) => replaceSostituzioni(chiave, sostituzioni))
  }

  const { traduzioni, fetched, fetching } = useSelector((state) => state.traduzioni)
  const mounted = useRef(false)

  useEffect(() => {
    mounted.current = true
  }, [traduzioni])

  useEffect(() => {
    mounted.current = true
  }, [])

  const getTraduzione = (chiave, sostituzioni) => {
    if (!chiave) {
      return
    }
    if (!fetched || fetching) {
      return chiave
    } else {
      const traduzione = traduzioni.find((t) => t.chiave.trim() === chiave.trim())

      if (traduzione) {
        return replaceSostituzioni(traduzione?.valore, sostituzioni)
      } else {
        api.post(TRADUZIONI, { chiave }).catch((error) => console.log(error))

        return replaceSostituzioni(chiave, sostituzioni)
      }
    }
  }

  return createTranslator(getTraduzione)
}
